import { config } from 'src/config/config';
import { languageNameToI18nLanguage, i18nLanguages } from 'src/config/i18n.config';

export const LANGUAGE_PREFERENCE_STORAGE_KEY = 'languagePreference';

export const getLanguageByLocale = (locale?: string) => {
    return locale && languageNameToI18nLanguage[locale];
};

export const getLanguageNameByLocale = (locale?: string) => {
    return Object.keys(languageNameToI18nLanguage).find(
        key => languageNameToI18nLanguage[key] === locale,
    );
};

const isLanguageAvailable = (language: string) => {
    return (i18nLanguages as readonly string[]).includes(language);
};

const getBrowserLanguage = () => navigator.language;

const saveLanguagePreferenceToLocalStorage = (language: string) => {
    localStorage.setItem(LANGUAGE_PREFERENCE_STORAGE_KEY, language);

    return language;
};

const getLanguagePreferenceFromLocalStorage = () => {
    return localStorage.getItem(LANGUAGE_PREFERENCE_STORAGE_KEY);
};

export const getPreferredLanguage = (localePreference?: string) => {
    if (localePreference) {
        return saveLanguagePreferenceToLocalStorage(
            getLanguageByLocale(localePreference) || config.defaultLanguage,
        );
    } else {
        let browserLanguage = getLanguagePreferenceFromLocalStorage() || getBrowserLanguage();
        if (browserLanguage === 'zh-CN') {
            browserLanguage = 'zh-Hans';
        }

        const languageWithCountry = ['en-US', 'fr-CA', 'zh-Hans'];

        //for other languages we need to remove country part in string
        if (!languageWithCountry.includes(browserLanguage)) {
            browserLanguage = browserLanguage.includes('-')
                ? browserLanguage.split('-')[0]
                : browserLanguage;
        }

        return saveLanguagePreferenceToLocalStorage(
            isLanguageAvailable(browserLanguage) ? browserLanguage : config.defaultLanguage,
        );
    }
};
